export const CONNECTION_STATE = {
    CONNECTED: Symbol('CONNECTED'),
    DISCONNECTED: Symbol('DISCONNECTED'),
    DISCONNECTED_WITH_RETRY: Symbol('DISCONNECTED_WITH_RETRY'),
};
